import { useState, useEffect,useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { login, userActivation } from '../Services/AuthService/AuthService';
import Footer from "../components/Footer/Footer";
import piri_logo from '../assets/images/about/piri_logo.png';
import { useAppContext } from '../context/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';

export default function LoginPage() {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const activate = searchParams.get("activate");
    const activatetoken = searchParams.get("token");
    const [isActivated, setIsActivated] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();
    const { updateUserData } = useAppContext();

    const activateAccount = async () => {
            try {
                const response = await userActivation(activatetoken);
                setSuccess(response.status)
            } catch (err) {
                setError(err.message)
            }
       

    };

    const hasActivated = useRef(false);

    useEffect(() => {
        if (activate && activatetoken && !hasActivated.current) {
            activateAccount();
            hasActivated.current = true; 
        }
    }, [activate, activatetoken]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await login(email, password);
            updateUserData(
                response.data.token,
                response.data.email,
                response.data.uni_id,
                response.data.uid,
                response.data.kturu
            );
            navigate('/');
        } catch (err) {
            console.log(err)
            toast.error(err?.response?.data?.status)
         
        }
    };

    return (
        <div className="min-h-screen bg-[#f5f6f6] flex items-center justify-center">
            <div className="flex w-full max-w-5xl bg-white rounded-lg shadow-lg overflow-hidden">
                {/* Left Section */}
                <div className="w-1/2 bg-[#f5f6f6] p-8">
                    <h2 className="text-2xl font-bold text-[#3c4f58] mb-6">
                    {t('Piri AI: Akademik Araştırmalar için Üretken Yapay Zeka')}
                    </h2>
                    <div className="text-justify">
                        <p className="text-gray-700 leading-relaxed mb-4">
                            {t('about3')}
                        </p>
                        <p className="text-gray-700 leading-relaxed">
                            {t('about4')}
                        </p>
                    </div>
                </div>


                {/* Right Section */}
                <div className="w-1/2 bg-white p-8">
                    <div className="flex justify-center mb-8">
                        <img
                            src={piri_logo}
                            alt="Piri AI Logo"
                            className="w-24"
                        />
                    </div>

                    {error && (
                        <div className="mb-4 p-2 bg-red-100 text-red-600 rounded text-sm">
                            {error}
                        </div>
                    )}
                    {success && (
                        <div className="mb-4 p-2 bg-red-100 text-success-600 rounded text-sm">
                            {success}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-[#3c4f58]"> {t('E-Mail')}</label>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                placeholder="isim.soyad@kurumunuz.edu.tr"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-[#3c4f58]"> {t('Şifre')}</label>
                            <input
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="mt-1 block w-full px-3 py-2 border border-[#3c4f58] rounded-md"
                                placeholder="••••••••"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-[#3c4f58] hover:bg-[#2c3e48]"
                        >
                             {t('Giriş Yap')}
                        </button>
                    </form>

                    <div className="mt-6 text-center space-y-4">
                        <a
                            href="https://kesifaraci.com/index.jsp?modul=password"
                            className="text-[#3c4f58] hover:text-[#2c3e48] block"
                        >
                           
                        </a>
                        <a
                            href="/register"
                            className="text-[#3c4f58] hover:text-[#2c3e48]"
                        >
                              {t('Hesabınız yok mu? Kayıt olun')}
                        </a>
                    </div>
                </div>
            </div>
            <Footer />
            <ToastContainer />
        </div>


    );
}